import { WholesalerContext, WholesalerContextShape } from './wholesaler-integration/WholesalerContext'
import { ClipspecContext, ClipspecContextShape } from './clipspec-integration/ClipspecContext'
import React from 'react'

export type BuilderMode = {
  name: 'standard'
} | {
  name: 'wholesaler'
  wholesalerContext: WholesalerContextShape
} | {
  name: 'clipspec'
  clipspecContext: ClipspecContextShape
}

export function useBuilderMode(): BuilderMode {
  const wholesalerContext = React.useContext(WholesalerContext)
  const clipspecContext = React.useContext(ClipspecContext)

  if (wholesalerContext) {
    return { name: 'wholesaler', wholesalerContext }
  }

  if (clipspecContext) {
    return { name: 'clipspec', clipspecContext }
  }

  return { name: 'standard' }
}